import { Injectable } from '@angular/core';
import { MessageBannerOptions } from '@com-delta-omnichannel/mach-core-js';

@Injectable({
  providedIn: 'root'
})
export class MyTripAdapterService {
  errorBannerMessage = '';
  messageBannerId = 'my-trip-message-banner';

  setErrorBanner(): MessageBannerOptions {
    return {
      id: this.messageBannerId,
      type: 'error',
      isSticky: false,
      hasBar: true,
      iconSize: 'large',
      content: {
        header: {
          title: '',
          hasCloseButton: false
        },
        description: this.errorBannerMessage
      }
    };
  }
}
